/* eslint-env node */

// Use require() instead of import for compatibility with stylus
const mpColors = require(`../stylesheets/mixins/colors.json`);

const activeColorScheme = {
  chrome: mpColors[`$chrome`],
  chromeUserIndicator: mpColors[`$blue3`],

  charts: {
    default: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`], // usually the text color
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart3`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart4`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart5`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart6`],
        secondary: mpColors[`$gray5`],
      },
      {
        primary: mpColors[`$chart7`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart8`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart9`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart10`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart11`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart12`],
        secondary: mpColors[`$white`],
      },
    ],

    previousComparison: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$gray3`],
        secondary: mpColors[`$gray5`],
      },
    ],

    funnels: [
      // funnels completion/dropoff card in dashboard, NOT the analytics Funnels page
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
    ],

    selectable: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
    ],

    retention: [
      {
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$gray5`],
      },
      {
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$gray5`],
      },
      {
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    campaignMessages: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart3`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart4`],
        secondary: mpColors[`$white`],
      },
    ],

    campaignEmails: [
      {
        primary: mpColors[`$chart1`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart2`],
        secondary: mpColors[`$white`],
      },
      {
        primary: mpColors[`$chart3`],
        secondary: mpColors[`$gray4`],
      },
    ],
  },

  primaryTextColor: mpColors[`$gray5`],
  secondaryTextColor: mpColors[`$gray4`],
  tertiaryTextColor: mpColors[`$gray3`],
  quaternaryTextColor: mpColors[`$gray3`],
  disabledTextColor: mpColors[`$gray2`],

  tabActiveText: mpColors[`$gray5`],
  tabInactiveText: mpColors[`$gray3`],
  tabActiveIndicator: mpColors[`$blue1`],

  placeholderText: mpColors[`$gray3`],

  controlPrimary: mpColors[`$blue1`],
  spinner: mpColors[`$blue1`],
  toast: mpColors[`$gray5`],

  upsell: mpColors[`$green1`],

  legendDivider: mpColors[`$gray2`],
  legendBackground: mpColors[`$gray1`],
  darkDivider: mpColors[`$gray2`],
  lightDivider: mpColors[`$gray1`],
  dataAnnotationText: mpColors[`$gray3`],
  tableHeaderBackground: mpColors[`$gray1`],

  positive: mpColors[`$green1`],
  negative: mpColors[`$red1`],

  starFavorite: mpColors[`$orange1`],
  menuItemBackground: mpColors[`$gray1`],
  tagBackground: mpColors[`$gray5`],

  icons: {
    default: mpColors[`$gray3`],
    disabled: mpColors[`$gray3`],
    hover: mpColors[`$blue1`],
    error: mpColors[`$red1`],
  },

  heatSteps: {
    correlatePositive: [
      {
        step: 0.05,
        primary: mpColors[`$positive-scale0`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.1,
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.2,
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.3,
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.4,
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.5,
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.6,
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.8,
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: Number.MAX_SAFE_INTEGER,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    correlateNegative: [
      {
        step: -0.05,
        primary: mpColors[`$negative-scale0`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.1,
        primary: mpColors[`$negative-scale1`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.2,
        primary: mpColors[`$negative-scale2`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.3,
        primary: mpColors[`$negative-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.4,
        primary: mpColors[`$negative-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.5,
        primary: mpColors[`$negative-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.6,
        primary: mpColors[`$negative-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: -0.8,
        primary: mpColors[`$negative-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: Number.MIN_SAFE_INTEGER,
        primary: mpColors[`$negative-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    /** TODO: delete me when data table goes live */
    retention: [
      {
        step: 0.125,
        primary: mpColors[`$positive-scale1`],
        secondary: mpColors[`$gray4`],
      },
      {
        step: 0.25,
        primary: mpColors[`$positive-scale2`],
        secondary: mpColors[`$gray4`],
      },
      {
        step: 0.375,
        primary: mpColors[`$positive-scale3`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.5,
        primary: mpColors[`$positive-scale4`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.625,
        primary: mpColors[`$positive-scale5`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.75,
        primary: mpColors[`$positive-scale6`],
        secondary: mpColors[`$white`],
      },
      {
        step: 0.875,
        primary: mpColors[`$positive-scale7`],
        secondary: mpColors[`$white`],
      },
      {
        step: 1.0,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
      {
        step: `incomplete`,
        primary: mpColors[`$white`],
        secondary: mpColors[`$gray3`],
      },
      {
        step: `zeroBucket`,
        primary: mpColors[`$positive-scale8`],
        secondary: mpColors[`$white`],
      },
    ],

    /** New color palette for data table. */
    retention2: [
      {
        step: 1 / 11,
        primary: mpColors[`$sequence-0`],
        secondary: mpColors[`$gray5`],
      },
      {
        step: 2 / 11,
        primary: mpColors[`$sequence-1`],
        secondary: mpColors[`$gray5`],
      },
      {
        step: 3 / 11,
        primary: mpColors[`$sequence-2`],
        secondary: mpColors[`$gray5`],
      },
      {
        step: 4 / 11,
        primary: mpColors[`$sequence-3`],
        secondary: mpColors[`$gray5`],
      },
      {
        step: 5 / 11,
        primary: mpColors[`$sequence-4`],
        secondary: mpColors[`$white`],
      },
      {
        step: 6 / 11,
        primary: mpColors[`$sequence-5`],
        secondary: mpColors[`$white`],
      },
      {
        step: 7 / 11,
        primary: mpColors[`$sequence-6`],
        secondary: mpColors[`$white`],
      },
      {
        step: 8 / 11,
        primary: mpColors[`$sequence-7`],
        secondary: mpColors[`$white`],
      },
      {
        step: 9 / 11,
        primary: mpColors[`$sequence-8`],
        secondary: mpColors[`$white`],
      },
      {
        step: 10 / 11,
        primary: mpColors[`$sequence-9`],
        secondary: mpColors[`$white`],
      },
      {
        step: 1,
        primary: mpColors[`$sequence-10`],
        secondary: mpColors[`$white`],
      },
      {
        step: `incomplete`,
        primary: mpColors[`$white`],
        secondary: mpColors[`$gray3`],
      },
      {
        step: `zeroBucket`,
        primary: mpColors[`$sequence-0`],
        secondary: mpColors[`$gray3`],
      },
    ],
  },

  jql: {
    token: {
      comment: `#578c4e`,
      default: `#5e6064`,
      keyword: `#a75c11`,
      literal: `#39946a`,
      number: `#46a609`,
      op: `#92188c`,
      sep: `#bdbec1`,
      string: `#6764c7`,
      variable: `#5e6064`,
    },
  },

  otherSegment: {
    primary: mpColors[`$other-segment`],
    secondary: mpColors[`$other-segment-secondary`],
  },
};

// old color scheme had variations that have since been deprecated
// map the keys to the correct color set in the new color scheme for backward compatibility
// left-hand-side references can be removed throughout all projects once new color scheme is fully rolled out
activeColorScheme.charts[`stackedBarChart`] = activeColorScheme.charts[`default`];
activeColorScheme.charts[`insights`] = activeColorScheme.charts[`default`];
activeColorScheme.charts[`pieChart`] = activeColorScheme.charts[`default`];
activeColorScheme.charts[`funnelsChart`] = activeColorScheme.charts[`default`];
activeColorScheme[`previousComparisonNeutralSegmentIconColor`] =
  activeColorScheme.charts[`previousComparison`][1].primary;
activeColorScheme[`barChartLegendBackground`] = activeColorScheme[`legendBackground`];
activeColorScheme[`barChartLegendDivider`] = activeColorScheme[`legendDivider`];
activeColorScheme[`chartTooltipPositive`] = activeColorScheme[`positive`];
activeColorScheme[`chartTooltipNegative`] = activeColorScheme[`negative`];
activeColorScheme[`correlateRangeBar`] = activeColorScheme[`legendDivider`];
activeColorScheme[`correlateTableHeaderDivider`] = activeColorScheme[`darkDivider`];
activeColorScheme[`correlateTableRowDivider`] = activeColorScheme[`darkDivider`];
activeColorScheme[`controlLabelText`] = activeColorScheme[`controlPrimary`];
activeColorScheme[`exploreLink`] = activeColorScheme[`controlPrimary`];
activeColorScheme[`retentionSelector`] = activeColorScheme[`controlPrimary`];

function rgbFromHexString(hexString) {
  const parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return (
    parts && {
      r: parseInt(parts[1], 16),
      g: parseInt(parts[2], 16),
      b: parseInt(parts[3], 16),
    }
  );
}

function rgbaStringFromHexString(hexString, a) {
  const parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return `rgba(${parseInt(parts[1], 16)}, ${parseInt(parts[2], 16)}, ${parseInt(parts[3], 16)}, ${a})`;
}

function hexStringFromRgb(rgb) {
  return `#${(0x1000000 + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).slice(1)}`;
}

function interpolateColor(startColor, endColor, percent) {
  // percent is a decimal in range [0,1]
  const startColorRGB = rgbFromHexString(startColor);
  const endColorRGB = rgbFromHexString(endColor);
  const interpolatedColorRGB = {
    r: startColorRGB.r + Math.floor(percent * (endColorRGB.r - startColorRGB.r)),
    g: startColorRGB.g + Math.floor(percent * (endColorRGB.g - startColorRGB.g)),
    b: startColorRGB.b + Math.floor(percent * (endColorRGB.b - startColorRGB.b)),
  };
  return hexStringFromRgb(interpolatedColorRGB);
}

function applyAlphaToColor(colorHexString, alpha, backgroundHexString) {
  const color = rgbFromHexString(colorHexString);
  const background = rgbFromHexString(backgroundHexString);
  return hexStringFromRgb({
    r: Math.floor((1 - alpha) * background.r + alpha * color.r),
    g: Math.floor((1 - alpha) * background.g + alpha * color.g),
    b: Math.floor((1 - alpha) * background.b + alpha * color.b),
  });
}

module.exports = {
  mpColors,
  ...activeColorScheme,
  getChartSegmentColorCombo(idx, chartType = `default`) {
    const palette = activeColorScheme.charts[chartType];
    return palette && palette[idx % palette.length];
  },
  getCorrelatePhiColorCombo(phi) {
    const steps =
      phi >= 0 ? activeColorScheme.heatSteps[`correlatePositive`] : activeColorScheme.heatSteps[`correlateNegative`]; // eslint-disable-line no-multi-spaces
    return steps.find((s) => (phi >= 0 ? phi < s.step : phi > s.step)); // eslint-disable-line no-multi-spaces
  },
  getRetentionColorCombo(heatPercent, zeroBucket = false, incomplete = false, useNewColors = true) {
    // @heatPercent is a decimal in the range [0,1]
    const steps = activeColorScheme.heatSteps[useNewColors ? `retention2` : `retention`];
    return (
      (incomplete && steps.find((s) => s.step === `incomplete`)) ||
      (zeroBucket && steps.find((s) => s.step === `zeroBucket`)) ||
      steps.find((s) => heatPercent <= s.step)
    );
  },
  getRetentionLineColorCombo(idx, lineCount) {
    const palette = activeColorScheme.charts[`retention`];
    const paletteInterval = 1 / (palette.length - 1);
    // Pick the darkest color if only 1 line.
    const linePercent = lineCount === 1 ? 1 : idx / (lineCount - 1);
    const roundedPalettePercent = Math.floor(linePercent / paletteInterval) * paletteInterval;
    const roundedPaletteIndex = Math.round(roundedPalettePercent * (palette.length - 1));
    return {
      primary: interpolateColor(
        palette[roundedPaletteIndex].primary,
        palette[Math.min(roundedPaletteIndex + 1, palette.length - 1)].primary,
        linePercent - roundedPalettePercent,
      ),
      secondary: palette[roundedPaletteIndex].secondary,
    };
  },
  hexStringFromRgb,
  interpolateColor,
  rgbFromHexString,
  rgbaStringFromHexString,
  applyAlphaToColor,
};
